import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useMutation} from '@tanstack/react-query';
import {getCompanyList, sendContactEmail} from '../library/api';
// import section1_m from '/assets/section1-m.svg';
const MainPage = () => {
    const navigation = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [searchTxt, setSearchTxt] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const token = localStorage.getItem('admin_token');
    // 퍄트너스 문의하기(문의 메일 발송)
    const {mutate: getCompanyListMutate, data: getCompanyListData} = useMutation({
        mutationFn: getCompanyList,
        mutationKey: ['getCompanyList'],
        onError: error => {
            if (error.response.data.code !== 401) {
                alert(error.response.data.message);
            }
            throw error;
        }
    });

    useEffect(() => {
        getCompanyListMutate({searchTxt: searchTxt});
    }, [searchTxt]);
    return (
        <>
            <main className="flex flex-col">
                {
                    !token ? (<section
                        className=" bg-section1-m sm:bg-section1 bg-center xl:bg-[length:100%] lg:bg-[length:110%] md:bg-[length:140%] sm:bg-[length:140%] bg-[length:80%] bg-no-repeat bg-[#3FBAB1] py-[85px] flex flex-col items-center px-4">
                        <h1 className="text-white font-bold lg:text-[50px] text-[36px] mb-10 text-center leading-[64px]">일사와
                            함께<br/>수익을 창출해보세요</h1>
                        <a onClick={() => navigation('/signUp')}
                           className="w-[212px] py-4 drop-shadow rounded-[30px] text-[#333333] font-extrabold text-[20px] border-teal-500 bg-white flex justify-center items-center">
                            회원가입<img className="ml-[2px]" src="/assets/next2.svg"/>
                        </a>
                    </section>) : ''
                }

                <section
                    className="flex lg:flex-row flex-col items-center gap-y-10 py-[100px] justify-center xl:gap-x-[100px] gap-x-10 px-5">
                    <div className="self-center">
                        <h1 className="font-extrabold xl:text-[50px] text-[36px] mb-7 text-[#333333] lg:text-left text-center">일사
                            파트너스</h1>
                        <p className="xl:text-[20px] font-medium leading-[36px] break-keep lg:text-left text-center text-[#454545]">
                            일사 파트너는 <b>일사 서비스에 잠재고객을 가입</b>시키고
                            <br/>
                            해당 고객으로 발생하는 <b>일사 서비스 수수료의 수익을 공유하는 프로그램</b>입니다.
                            <br/>
                            한번 고객 유치로 파트너에게는 매월 지급되는 불로소득의 기회입니다.
                        </p>
                    </div>
                    <img src="/assets/section2.png" className="xl:w-[468px] xl:h-[397px] w-[368px] h-[297px]"/>
                </section>
                <section
                    className="bg-[#ECF8F7] pt-[120px] gap-y-10 px-4 flex lg:flex-row flex-col-reverse items-center justify-center xl:gap-x-[100px] gap-x-10 px-5">
                    <img src="/assets/section3.png" className="xl:w-[428px] xl:h-[478px] x-[328px] h-[378px]"/>
                    <div className="self-center">
                        <h1 className="font-extrabold xl:text-[50px] text-[36px] mb-7 text-[#333333] lg:text-left text-center">일사
                            서비스</h1>
                        <p className="xl:text-[20px] font-medium leading-[36px] break-keep lg:text-left text-center text-[#454545]">
                            일사(일과 사람)는 건설, 제조, 용역 등 다양한 분야의 회사/단체에서
                            <br/>
                            관리 업무를 자동화해주는 서비스 플랫폼입니다.
                            <br/>
                            자세한 내용은 일사 홈페이지(<a className="text-teal-500 font-bold" href="https://ilsaram.co.kr/"
                                               target="_blank">www.ilsaram.co.kr</a>)에서 확인할 수 있습니다.
                            <br/>
                            (문의 : <b>partners@netsprint.net / 1566-1013</b>)
                        </p>
                    </div>
                </section>
                <section className="py-[150px] px-4 flex flex-col items-center px-5">
                    <h2 className="font-extrabold text-[36px] text-[#333333] mb-[60px]">어떻게 사용하나요?</h2>
                    <div className="flex lg:flex-row flex-col gap-y-6 justify-center items-center gap-x-6">
                        <div
                            className="xl:w-[384px] lg:w-[300px] w-[384px] xl:h-[342px] lg:h-[300px] h-[342px] flex flex-col border border-gray-200 rounded-[24px] xl:py-9 lg:py-5 py-9 xl:px-10 lg:px-5 px-10 bg-no-repeat bg-[right_28px_bottom_28px] bg-section4-1">
                            <h3 className="font-extrabold xl:text-[24px] text-[22px] text-[#333333] mb-3"><span
                                className="text-teal-500">01 </span>고객 검색</h3>
                            <p className="font-medium xl:text-[18px] text-[15px] text-gray-500 mb-7">
                                잠재고객(건설, 제조사 등)이
                                <br/>
                                일사에 가입되어 있는지 검색해 보세요.
                            </p>
                            <button onClick={() => {
                                setModalOpen(true);
                                setSearchValue('');
                                setSearchTxt('');
                            }}
                                    className="xl:w-[150px] w-[138px] flex justify-center items-center xl:py-3 py-2 bg-teal-500 rounded-[30px] text-white font-bold">
                                회사명 검색<img className="ml-2" src="/assets/next_white.png"/>
                            </button>
                        </div>
                        <div
                            className="xl:w-[384px] lg:w-[300px] w-[384px] xl:h-[342px] lg:h-[300px] h-[342px] flex flex-col border border-gray-200 rounded-[24px] xl:py-9 lg:py-5 py-9 xl:px-10 lg:px-5 px-10 bg-no-repeat bg-[right_28px_bottom_28px]">
                            <h3 className="font-extrabold xl:text-[24px] text-[22px] text-[#333333] mb-3"><span
                                className="text-teal-500">02 </span>영업 활동</h3>
                            <p className="font-medium xl:text-[18px] text-[15px] text-gray-500 mb-7">
                                검색한 회사가 미가입 고객이라면
                                <br/>
                                서비스 사용을 적극적으로 설득해 주세요.
                            </p>
                        </div>
                        <div
                            className="xl:w-[384px] lg:w-[300px] w-[384px] xl:h-[342px] lg:h-[300px] h-[342px] flex flex-col border border-gray-200 rounded-[24px] xl:py-9 lg:py-5 py-9 xl:px-10 lg:px-5 px-10 bg-no-repeat bg-[right_28px_bottom_28px]">
                            <h3 className="font-extrabold xl:text-[24px] text-[22px] text-[#333333] mb-3"><span
                                className="text-teal-500">03 </span>수익 창출</h3>
                            <p className="break-keep font-medium xl:text-[18px] text-[15px] text-gray-500 mb-7">
                                파트너 소개로 고객 가입이 되면
                                <br className="xl:hidden"/>
                                해당 고객으로 발생하는 '일사 서비스 수수료'의
                                <br className="xl:block hidden"/>
                                N%를 매월 수익으로 지급합니다.
                            </p>
                        </div>
                    </div>
                </section>
            </main>
            {
                modalOpen && <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title"
                                  role="dialog" aria-modal="true">
                    <div
                        className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                             aria-hidden="true"></div>

                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"
                              aria-hidden="true">&#8203;</span>

                        <div x-show="searchModalOpen"
                             className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                            <div className="bg-white p-4 sm:p-10">
                                <div className="flex justify-between items-center mb-7">
                                    <h3 className="font-extrabold text-[24px]">회사명 검색</h3>
                                    <img src="./assets/close.svg" className="cursor-pointer"
                                         onClick={() => setModalOpen(false)}/>
                                </div>
                                <div className="flex justify-center items-center mb-5 gap-x-1">
                                    <div className="w-full flex items-center ml-3">
                                        <img src="./assets/search.svg" className="mr-[-30px] z-10"/> <input type="text"
                                                                                                            placeholder="넷스프린트"
                                                                                                            onChange={event => {
                                                                                                                setSearchValue(event.target.value);
                                                                                                            }}
                                                                                                            value={searchValue}
                                                                                                            onKeyDown={(e) => {
                                                                                                                if (e.key === 'Enter' && e.nativeEvent.isComposing === false) {
                                                                                                                    if (e.target.value.length < 2 || e.target.value.trim().length < 2) {
                                                                                                                        alert('회사명은 두글자 이상 입력해 주세요');
                                                                                                                        setSearchValue(e.target.value.trim());
                                                                                                                        return;
                                                                                                                    }
                                                                                                                    setSearchValue(e.target.value.trim());
                                                                                                                    setSearchTxt(e.target.value);
                                                                                                                }
                                                                                                            }}
                                                                                                            className="w-full w-text-[15px] text-[#9B9B9B] border border-gray-200 rounded-[10px] pl-10 py-3"/>
                                    </div>
                                    <button onClick={event => {
                                        event.preventDefault();
                                        if (searchValue.length < 2 || searchValue?.trim().length < 2) {
                                            alert('회사명은 두글자 이상 입력해 주세요');
                                            setSearchValue(searchValue?.trim());
                                            return;
                                        }
                                        setSearchTxt(searchValue);
                                    }}
                                            className="bg-[#202020] whitespace-nowrap text-[14px] text-white rounded-[10px] px-5 py-3">검색
                                    </button>
                                </div>
                                {
                                    searchTxt !== '' && (<div>
                                        <div className="border-b border-gray-200 pb-2 mb-7">
                                            <p className="text-[15px]">검색하신 회사명은 '<span
                                                className="text-teal-500 font-bold">{searchTxt}</span>'입니다.</p>
                                        </div>
                                        <div className="border-b border-gray-200 pb-2">
                                            <p className="text-teal-500 text-[15px] font-bold">{getCompanyListData?.list?.length > 0 ? '유사 이름의 가입 고객이 있습니다.' : '가입 고객이 없습니다.'}</p>
                                        </div>
                                        {
                                            getCompanyListData?.list && getCompanyListData?.list?.map((e, i) => (
                                                <div className="border-b border-gray-200 p-2" key={i}>
                                                    <p className="text-[15px] font-bold">{e}</p>
                                                </div>
                                            ))
                                        }
                                    </div>)
                                }

                                {/*<div className="border-b border-gray-200 p-2">*/}
                                {/*    <p className="text-[15px] font-bold">삼성전자</p>*/}
                                {/*</div>*/}
                                {/*<div className="border-b border-gray-200 p-2">*/}
                                {/*    <p className="text-[15px] font-bold">삼성생명</p>*/}
                                {/*</div>*/}
                                {/*<div className="border-b border-gray-200 p-2">*/}
                                {/*    <p className="text-[15px] font-bold">(주)삼성물산</p>*/}
                                {/*</div>*/}
                                {/*<div className="border-b border-gray-200 p-2">*/}
                                {/*    <p className="text-[15px] font-bold">삼성물산(주)</p>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            }

        </>
    );
};

export default MainPage;
